import * as Cesium from 'cesium';
import { DualEntityCollection } from '../types';

export function createDualDataSource(
  primaryDS: Cesium.CustomDataSource,
  getSecondaryDS: () => Cesium.CustomDataSource | null | undefined,
) {
  return {
    _primaryDS: primaryDS,
    entities: new DualEntityCollection(primaryDS.entities, () => {
      const secDS = getSecondaryDS();
      return secDS ? secDS.entities : null;
    }),
    show: primaryDS.show,
  } as unknown as Cesium.CustomDataSource;
}
